module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_hokkaido-fd3c2dd08cddaa72999ee88b160dc8d7.png";